import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'professionals',
  children: {
    incidences: {
      path: 'incidences',
      size: 'full',
      children: {
        details: {
          path: ':id',
          size: 'full',
        },
        idChanges: {
          path: ':id/changes',
          size: 'full',
        },
        idNotes: {
          path: ':id/notes',
          size: 'full',
        },
        idMessages: {
          path: ':id/messages',
          size: 'full',
        },
        idTasks: {
          path: ':id/tasks',
          size: 'full',
        },
      },
    },
    clients: {
      path: 'clients',
      size: 'full',
      children: {
        payrollResults: {
          path: 'payroll-results',
          size: 'full',
          children: {
            payrollPolicy: {
              path: 'policy/:policyId',
              size: 'full',
              children: {
                payrollPolicyPeriodId: {
                  path: 'period/:periodId',
                  size: 'full',
                  children: {
                    sync: {
                      path: 'sync',
                      size: 'full',
                    },
                    export: {
                      path: 'export',
                      size: 'full',
                    },
                    upload: {
                      path: 'upload',
                      size: 'full',
                    },
                  },
                },
              },
            },
            payrollResultsId: {
              path: ':policyId',
              size: 'full',
              children: {
                export: {
                  path: 'export',
                  size: 'full',
                },
                upload: {
                  path: 'upload',
                  size: 'full',
                },
              },
            },
          },
        },
        preferences: {
          path: 'preferences',
          size: 'full',
        },
      },
    },
    settings: {
      path: 'settings',
      size: 'full',
    },
    companies: {
      path: 'companies',
      size: 'full',
    },
  },
} as const satisfies Location
